"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createHistory = require("./createHistory");

var _createHistory2 = _interopRequireDefault(_createHistory);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Wrap a <Router> using unique HTML5 history.
 */


var BrowserHistoryRouter = function (_Component) {
  _inherits(BrowserHistoryRouter, _Component);

  function BrowserHistoryRouter(props, context) {
    _classCallCheck(this, BrowserHistoryRouter);

    var _this = _possibleConstructorReturn(this, (BrowserHistoryRouter.__proto__ || Object.getPrototypeOf(BrowserHistoryRouter)).call(this, props, context));

    _this.history = (0, _createHistory2.default)();
    return _this;
  }

  _createClass(BrowserHistoryRouter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          history = _props.history,
          children = _props.children;
      return _react2.default.createElement(_reactRouter.Router, {
        history: history || this.history,
        children: children
      });
    }
  }]);

  return BrowserHistoryRouter;
}(_react.Component);

BrowserHistoryRouter.propTypes = {
  children: _propTypes2.default.node,
  history: _propTypes2.default.object
};
exports.default = BrowserHistoryRouter;